import { render } from "./UpcomingMatches.vue?vue&type=template&id=05f9af09&scoped=true"
import script from "./UpcomingMatches.vue?vue&type=script&lang=js"
export * from "./UpcomingMatches.vue?vue&type=script&lang=js"

import "./UpcomingMatches.vue?vue&type=style&index=0&id=05f9af09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f9af09"]])

export default __exports__